import { Chip } from "matsuri-ui"
import { PhotoTour } from "@/domain/photoTour"

export const TourChip = ({ photoTour }: { photoTour: PhotoTour }) => {
    return <Chip>{photoTour?.title}</Chip>
}
